import * as React from 'react';

import { cn } from '@/helpers/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    unStyled?: boolean;
}

const inputVariants =
    'flex h-14 w-full rounded-2xl border border-[#C5C7C9] bg-background p-4 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#8F9193] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50';

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, unStyled, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(unStyled ? '' : inputVariants, className)}
                ref={ref}
                {...props}
            />
        );
    }
);
Input.displayName = 'Input';

export { Input, inputVariants };
